
import { NgModule          } from '@angular/core';
import { CommonModule      } from '@angular/common';
import { HttpClientModule  } from '@angular/common/http';
import { CarouselModule    } from 'ngx-owl-carousel-o';

import { MainRouting   } from './main.routing';
import { MainComponent } from './main.component';

import { SectionAboutComponent        } from './section-about/section-about.component';
import { SectionBannerComponent       } from './section-banner/section-banner.component';
import { SectionGalleryComponent      } from './section-gallery/section-gallery.component';
import { SectionContactComponent      } from './section-contact/section-contact.component';
import { SectionLocationComponent     } from './section-location/section-location.component';
import { SectionCompaniesComponent    } from './section-companies/section-companies.component';
import { SectionApartmentsComponent   } from './section-apartments/section-apartments.component';
import { SectionPerspectivesComponent } from './section-perspectives/section-perspectives.component';
import {
    Facebook
} from 'angular-feather/icons';
import { FeatherModule } from 'angular-feather';

const icons = {
    Facebook
};

@NgModule({
    imports: [
        MainRouting,
        CommonModule,
        HttpClientModule,
        CarouselModule,
        FeatherModule.pick(icons)
    ],
    declarations: [
        MainComponent,
        SectionAboutComponent,
        SectionBannerComponent,
        SectionGalleryComponent,
        SectionContactComponent,
        SectionLocationComponent,
        SectionCompaniesComponent,
        SectionApartmentsComponent,
        SectionPerspectivesComponent
    ]
})
export class MainModule {

}
